'use client';

import { usePathname } from 'next/navigation';
import { Navigation } from './navigation';
import { ROUTES } from '@/config/router';
import { useIsMobile } from '@/lib/is-mobile';

export function NavigationWrapper() {
  const pathname = usePathname();
  const isMobile = useIsMobile();

  // Không hiển thị navigation nếu là route trong folder (m)
  // Pattern: /[locale]/m/* hoặc /[locale]/order-wv/*
  const isHiddenScreen =
    pathname.includes('/m') ||
    pathname.includes('/order-wv/') ||
    pathname === ROUTES.home;

  if (!isMobile || isHiddenScreen) {
    return null;
  }

  return <Navigation />;
}
